(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('GeneralSettingsController', GeneralSettingsController);

    GeneralSettingsController.$inject = ['$uibModal', '$scope', '$state', '$rootScope', 'TabDomains', 'domain', 'UserAlertService', 'AlertRules', '$timeout', 'AlertService', 'MaintenanceSettingsService', 'maintenanceSetting', 'DomainAlertService', 'Principal', 'Auth', 'User'];

    function GeneralSettingsController($uibModal, $scope, $state, $rootScope, TabDomains, domain, UserAlertService, AlertRules, $timeout, AlertService, MaintenanceSettingsService, maintenanceSetting, DomainAlertService, Principal, Auth, User) {
        var vm = this;
        // general settings variables
        vm.enableAlerting = false;
        vm.mailIntegration = false;
        vm.telegramIntegration = false;
        vm.webhookIntegration = false;
        vm.tabDomain = domain;
        vm.maintenanceSetting = undefined;
        vm.showMaintenanceForm = false;
        vm.domain = {};
        vm.newtrusted = {};
        vm.newtrusted.email = [];
        vm.newtrusted.telegram = [];
        vm.newtrusted.webhook = [];
        vm.throttleUnit = ["minutes", "hours", "days", "weeks"];
        vm.mailType = "none";
        vm.settingsAccount = null;
        vm.datePickerOptions = {
            minDate: new Date()
        };
        //my channel variables
        vm.promise = {};
        vm.licence = $rootScope.licence;
        vm.promise = {};
        vm.licence = $rootScope.licence;
        vm.authorities = [];

        // INIT SECTION get all the needed resources
        vm.init = function () {
            //init general settings resources
            maintenanceSetting.$promise.then(function (data) {
                if (angular.isDefined(data)) {
                    vm.maintenanceSetting = data;
                    vm.maintenanceSetting.releaseDate = new Date(data.releaseDate);
                    vm.showMaintenanceForm = true;
                    vm.maintenanceSetting.version !== "null" ? vm.mailType = "maintenance" : vm.mailType = "notice";
                }
            });
            Principal.identity(true).then(function (account) {
                vm.settingsAccount = vm.copyAccount(account);
                vm.settingsNotification = vm.copyNotification(account);
                vm.authorities = angular.copy(account.authorities);
                $timeout(function (){
                    if (vm.authorities.includes('ROLE_DOMAIN_USER') === true) {
                        if (vm.tabDomain.mailAlerting === false) {
                            vm.settingsNotification.warningEmail = angular.copy(vm.tabDomain.mailAlerting);
                        }
                        if (vm.tabDomain.telegramAlerting === false) {
                            vm.settingsNotification.warningTelegram = angular.copy(vm.tabDomain.telegramAlerting);
                        }
                        if (vm.tabDomain.webhookAlerting === false) {
                            vm.settingsNotification.webhook = angular.copy(vm.tabDomain.webhookAlerting);
                        }
                    }
                });
            });
            User.getTerms({}, onSuccessCheck, onErrorCheck);
            vm.loadAll()
            vm.trustedDomainGeneralSettings();
            vm.enableAlerting = vm.tabDomain.enableAlerting;
        }

        vm.loadAll = function () {
            DomainAlertService.getUserAlertSystem({user: 'logged'}, onSuccess);
            DomainAlertService.getAuthentications(function (result) {
                vm.authentications = result;
                vm.authentication = 'none';
            });
        }

        vm.trustedDomainGeneralSettings = function () {
            vm.trusted = {};
            vm.trusted.email = [];
            vm.trusted.telegram = [];
            vm.trusted.webhook = [];
            UserAlertService.getUserAlertingSettings({alertType: 'email'}, function (result) {
                vm.trusted.email = result;
                vm.trusted.email.forEach(function (value) {
                    value.saved = true;
                });
            });
            UserAlertService.getUserAlertingSettings({alertType: 'telegram'}, function (result) {
                vm.trusted.telegram = result;
                vm.trusted.telegram.forEach(function (value) {
                    value.saved = true;
                });
            });
            UserAlertService.getUserAlertingSettings({alertType: 'webhook'}, function (result) {
                vm.trusted.webhook = result;
                vm.trusted.webhook.forEach(function (value) {
                    value.saved = true;
                });
            });

        }

        vm.copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        vm.copyNotification = function (account) {
            return account.notification;
        };

        // SERVICE CALLBACK SECTION all the callback function are down here
        vm.setAlertConf = function () {
            vm.testEmail = false;
            vm.testTelegram = false;
            vm.testWebhook = false;
        };

        var onSaveSuccess = function (result) {
            AlertService.success("Notification channel successfully configured.");
            $timeout(function () {
                vm.isSaving = false;
                vm.loadAll();
            }, 1000);
        };

        var onSaveError = function (result) {
            vm.isSaving = false;
            AlertService.error("The code is invalid or expired");
        };

        var onSaveSuccessGeneral = function () {
            vm.isSaving = false;
        };

        var onSaveErrorGeneral = function () {
            vm.isSaving = false;
            TabDomains.current(function (result) {
                vm.tabDomain = result;
            });

        };

        function onSuccess(results) {
            vm.email = {};
            vm.telegram = {};
            vm.webhook = {};
            results.forEach(function (alert) {
                if (alert.alertSystemType.name == "email") {
                    vm.email = alert;
                } else if (alert.alertSystemType.name == "telegram") {
                    vm.telegram = alert;
                } else if (alert.alertSystemType.name == "webhook") {
                    vm.webhook = alert;
                    vm.authentication = alert.webhookIntegration.authType;
                }
            });
            vm.setAlertConf();
        }

        function onTestError(result) {
            if (result.status == 403) {
                AlertService.error("Channel domain is not trusted");
                vm.isSaving = false;
            } else {
                AlertService.error(result.data ? result.data.description : "Test fail");
                vm.isSaving = false;
            }
        }

        function onSuccessCheck(response) {
            vm.updateCheck = {};
            vm.updateCheck.check1 = response.check1;
            vm.updateCheck.check2 = response.check2;
            vm.updateCheck.check3 = response.check3;
        }

        function onErrorCheck(error) {
            console.log(error);
        }

        function onCheckSuccess(data) {
            $interval.cancel(vm.promise);
            vm.promise = undefined;
            vm.window.close();
        }

        function onCheckError(data) {
            if (data.status !== 404)
                $interval.cancel(vm.promise);
        }


        // SAVE SECTION all the function with service calls to save the page status
        vm.save = function (type, code) {
            vm.isSaving = true;
            if (type === 'Email') {
                DomainAlertService.checkMailCode({authorizationCode: code}, onSaveSuccess, onSaveError);
            } else if (type === "Telegram") {
                DomainAlertService.checkTelegramCode({authorizationCode: code}, onSaveSuccess, onSaveError);
            } else if (type === "Webhook") {
                DomainAlertService.saveWebhook(onSaveSuccess, onSaveError);
            }
        }

        vm.saveThrottle = function (type, allWarning, values) {
            vm[type] = values;
            if (vm[type].throttle === undefined) {
                AlertService.error("Throttle time must be between 1 and 59.");
            } else {
                vm.wac = {};
                vm.wac.alertSystemType = {};
                vm.wac.alertSystemType.name = type;
                if (vm[type].time === "minutes") {
                    vm.wac.throttlePeriod = vm[type].throttle;
                } else if (vm[type].time === "hours") {
                    vm.wac.throttlePeriod = vm[type].throttle * 60;
                } else if (vm[type].time === "days") {
                    vm.wac.throttlePeriod = vm[type].throttle * 60 * 24;
                } else if (vm[type].time === "weeks") {
                    vm.wac.throttlePeriod = vm[type].throttle * 60 * 24 * 7;
                }
                AlertRules.toggleChannel({
                    warningAlertConfiguration: vm.wac,
                    warning: vm.warning,
                    allWarning: allWarning
                }, function (result) {
                    vm.warning = result;
                    AlertService.success("Throttle time saved for all alerts in this channel.");
                }, function (result) {
                    AlertService.error("Error saving throttle.");
                });
            }
        };
        // check if remove is needed
        vm.saveGeneral = function (channelSettings) {
            vm.isSaving = true;
            var body = {
                tabDomains: vm.tabDomain,
                enable: vm.tabDomain[channelSettings],
                channel: channelSettings
            }
            TabDomains.requestToUpdateSettings(body, onSaveSuccessGeneral, onSaveErrorGeneral);
        };

        vm.saveToggle = function (crossCheck, propName) {
            if (vm.tabDomain[crossCheck] === false){
                $timeout(function (){
                    vm.settingsNotification[propName] = false;
                });
                // open modal here
                $uibModal.open({
                    templateUrl: 'app/account/general-settings/modals/channel-disabled.html',
                    controller: function ($uibModalInstance) {
                        var vm = this;
                        vm.clear = clear;
                        vm.stop = stop;

                        function stop() {
                            $uibModalInstance.close();
                        }

                        function clear() {
                            $uibModalInstance.dismiss('cancel');
                        }
                    },
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function () {
                });
            } else {
                Auth.updateAccount(vm.settingsAccount).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    Principal.identity(true).then(function (account) {
                        vm.settingsAccount = vm.copyAccount(account);
                    });
                    User.setTerms(vm.updateCheck);
                    User.updateNotifications({
                        login: vm.settingsAccount.login,
                        notification: vm.settingsNotification
                    }).$promise.then( function () {
                        vm.loadAll();
                    });
                    AlertService.success("Your notificiations settings have been updated");
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        vm.saveMaintenanceGeneral = function () {
            delete vm.maintenanceSetting.id;

            if (vm.maintenanceSetting.description === "" || vm.maintenanceSetting.description == null) {
                vm.maintenanceSetting.description =
                    "Version: \n" + vm.maintenanceSetting.version + "\n" +
                    "\nNew Features:\n" + vm.maintenanceSetting.features + "\n" +
                    "\nEnhancements:\n" + vm.maintenanceSetting.enhancements + "\n" +
                    "\nBugs Fixing:\n" + vm.maintenanceSetting.bugsFixing;
            } else {
                evaluate(vm.maintenanceSetting.version) ? vm.maintenanceSetting.version = "null" : vm.maintenanceSetting.version;
                evaluate(vm.maintenanceSetting.features) ? vm.maintenanceSetting.features = "null" : vm.maintenanceSetting.features;
                evaluate(vm.maintenanceSetting.enhancements) ? vm.maintenanceSetting.enhancements = "null" : vm.maintenanceSetting.enhancements;
                evaluate(vm.maintenanceSetting.bugsFixing) ? vm.maintenanceSetting.bugsFixing = "null" : vm.maintenanceSetting.bugsFixing;
            }

            MaintenanceSettingsService.save(vm.maintenanceSetting);
        };

        vm.updateTogglesOnAction = function (type) {
            if (type === 'email' || type === 'mailAlerting') {
                vm.settingsNotification.warningEmail = false;
            } else if (type === 'telegram' || type === 'telegramAlerting') {
                vm.settingsNotification.warningTelegram = false;
            } else {
                vm.settingsNotification.warningWebhook = false;
            }
            if (vm.tabDomain.enableAlerting === false) {
                vm.settingsNotification.warningEmail = false;
                vm.settingsNotification.warningTelegram = false;
                vm.settingsNotification.warningWebhook = false;
            }
            vm.saveToggle();
        //    build
        }

        //MODALS SECTION all modals function and controllers
        function configurationModalController($uibModalInstance, type, authentications) {
            var vm = this;
            if (authentications) {
                vm.authentications = authentications;
            }
            vm.type = type;
            vm.testAlert = testAlert;

            function testAlert() {
                $scope.isSaving = true;
                if (type === 'Email') {
                    DomainAlertService.sendMailCode({email: vm.email.actionIdentifier}, function () {
                        vm.testEmail = true;
                        vm.isSaving = false;
                    }, onTestError);
                } else if (type === "Webhook") {
                    if (vm.oauth) {
                        vm.webhook.oauthScheme = 1;
                    }
                    DomainAlertService.checkWebhook(vm.webhook, function () {
                        vm.testWebhook = true;
                        vm.isSaving = false;
                        AlertService.success("The url is valid and can be used as notification channel.");
                    }, onTestError);
                }
            }

            // set email
            vm.save = function (type, code) {
                $uibModalInstance.close({type: type, code: code});
            }

            // cancel operation
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function saveThrottleConfigurationController($uibModalInstance, data) {
            var vm = this;
            vm.type = data.type;
            vm.throttleUnit = data.throttleUnit;

            vm.save = function (type, values) {
                // route to save then outside of modal
                $uibModalInstance.close({type: vm.type, values: values});
            }

            // cancel operation
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function domainSettingConfigurationController($uibModalInstance, data) {
            var vm = this;
            vm.email = data.email;
            vm.webhook = data.webhook;
            vm.domain = data.domain;
            vm.trusted = data.trusted;
            vm.setting = data.settings;
            vm.newtrusted = data.newtrusted;
            vm.domainToDelete = [];
            vm.showWarningResult = false;
            vm.isConfirmOperation = false;

            vm.addDomainGeneral = function (type) {
                vm.newDomain = {};
                vm.newDomain.trustedDomain = vm.domain[type];
                vm.trusted[type].push(vm.newDomain);
                vm.newtrusted[type].push(vm.domain[type]);
                vm.domain[type] = "";
            };

            vm.saveSettingsGeneral = function (type) {
                vm.dataObject = {
                    domainsToAdd: null,
                    domainsToDelete: null
                };
                vm.alertingSettings = [];
                vm.newtrusted[type].forEach(function (element) {
                    vm.setting = {};
                    vm.setting.alertSystemType = {};
                    vm.setting.alertSystemType.name = type;
                    vm.setting.domain = vm.domain.id;
                    vm.setting.trustedDomain = element;
                    vm.alertingSettings.push(vm.setting);
                });
                if (vm.alertingSettings.length > 0) {
                    UserAlertService.checkUserAddAlertingSettings({alertType: type}, vm.alertingSettings, function (result) {
                        if (result.length > 0) {
                            // change view of modal and do additional steps
                            vm.isConfirmOperation = true;
                            vm.showWarningResult = true;
                            vm.alertsToDelete = [];
                            vm.newtrusted[type] = [];
                            vm.dataObject.domainsToAdd = angular.copy(vm.alertingSettings);
                            vm.dataObject.domainsToDelete = angular.copy(vm.domainToDelete);
                            vm.save(type, vm.dataObject);
                        } else {
                            vm.dataObject.domainsToAdd = angular.copy(vm.alertingSettings);
                            vm.dataObject.domainsToDelete = angular.copy(vm.domainToDelete);
                            vm.save(type, vm.dataObject);
                        }
                    });
                } else {
                    vm.dataObject.domainsToAdd = angular.copy(vm.alertingSettings);
                    vm.dataObject.domainsToDelete = angular.copy(vm.domainToDelete);
                    vm.save(type, vm.dataObject);
                }
            };

            vm.checkAndPrepareToDelete = function (trusted) {
                if (trusted.selected !== true) {
                    UserAlertService.checkUserDeleteAlertingSettings({id: trusted.id}, function (result) {
                        if (result.length > 0) {
                            if (!vm.domainToDelete.find(x => x.id === trusted.id)) {
                                vm.domainToDelete.push(trusted);
                            }
                            vm.isConfirmOperation = true;
                            trusted.toBeDeleted = true;
                            trusted.selected = true;
                        } else {
                            if (!vm.domainToDelete.find(x => x.id === trusted.id)) {
                                vm.domainToDelete.push(trusted);
                            }
                            trusted.greyout = true;
                            trusted.selected = true;
                        }
                    });
                } else {
                    vm.domainToDelete = vm.domainToDelete.filter(x => x.id !== trusted.id)
                    trusted.toBeDeleted = false;
                    trusted.greyout = false;
                    trusted.selected = false
                }
            }

            // set email
            vm.save = function (typeOfOperation, toSaveData) {
                if (vm.isConfirmOperation === true) {
                    typeOfOperation = 'confirmation';
                }
                // route to save then outside of modal
                $uibModalInstance.close({typeOfOperation: angular.copy(typeOfOperation), toSaveData: angular.copy(toSaveData)});
            }

            // cancel operation
            vm.clear = function () {
                $uibModalInstance.dismiss('cancel');
            }
        }

        vm.deleteAlert = function (id, type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/delete-dialog.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.clear = clear;
                    vm.stop = stop;

                    function stop() {
                        DomainAlertService.delete({id: id}, function (result) {
                            $state.reload();
                        }, onSaveError);
                        $uibModalInstance.close();
                    }

                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function () {
                vm.updateTogglesOnAction(type);
                AlertService.success("entity.delete.deleteChannel")
            });
        };

        vm.openToggleModal = function (notificationStatus, channelSettings) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/toggle-domain-notifications.html',
                controller: function ($uibModalInstance) {
                    var vm = this;
                    vm.channelSettings = channelSettings;
                    vm.notificationStatus = notificationStatus;
                    vm.clear = clear;
                    vm.stop = stop;

                    function stop() {
                        $uibModalInstance.close();
                    }

                    function clear() {
                        notificationStatus = !notificationStatus;
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                }
            }).result.then(function (result) {
                vm.saveGeneral(channelSettings);
                vm.isSaving = false;
            }, function (){
                if (channelSettings === 'mailAlerting') {
                    vm.tabDomain.mailAlerting = !vm.tabDomain.mailAlerting;
                }
                else if (channelSettings === 'telegramAlerting') {
                    vm.tabDomain.telegramAlerting = !vm.tabDomain.telegramAlerting;
                }
                else if (channelSettings === 'webhookAlerting') {
                    vm.tabDomain.webhookAlerting = !vm.tabDomain.webhookAlerting;
                } else if (channelSettings === 'enableAlerting') {
                    vm.tabDomain.enableAlerting = !vm.tabDomain.enableAlerting;
                }
            });
        }


        vm.openMailModal = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/email-setup.html',
                controller: configurationModalController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    type: function () {
                        return type
                    },
                    authentications: function () {
                        return null
                    }
                }
            }).result.then(function (result) {
                vm.save(result.type, result.code);
                vm.isSaving = false;
            });
        };

        vm.openTelegramModal = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/telegram-setup.html',
                controller: configurationModalController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    type: function () {
                        return type
                    },
                    authentications: function () {
                        return null
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                vm.save(result.type, result.code);
            });
        };

        vm.openWebhookModal = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/webhook-setup.html',
                controller: configurationModalController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    type: function () {
                        return type
                    },
                    authentications: function () {
                        return vm.authentications
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                vm.save(result.type, result.code);
            });
        };

        vm.openDomainSetting = function () {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/domain-emails-setup.html',
                controller: domainSettingConfigurationController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    data: function () {
                        return {
                            domain: vm.domain,
                            email: vm.email,
                            webhook: vm.webhook,
                            trusted: vm.trusted,
                            settings: vm.setting,
                            newtrusted: vm.newtrusted
                        }
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                if (result.toSaveData.domainsToAdd.length > 0) {
                    UserAlertService.userAlertingSettings({alertType: 'email'}, result.toSaveData.domainsToAdd).$promise.then(function () {
                        vm.trustedDomainGeneralSettings();
                    });
                }
                if (result.toSaveData.domainsToDelete.length > 0) {
                    // needs massive delete accepting a list as parameter
                    var cleanedArray = result.toSaveData.domainsToDelete.map((domain) => {
                        return {
                            alertSystemType: domain.alertSystemType,
                            domain: domain.domain,
                            id: domain.id,
                            trustedDomain: domain.trustedDomain
                        }
                    });
                    UserAlertService.deleteProvidedRequest({toDelete: cleanedArray});
                    vm.trustedDomainGeneralSettings();
                }
            });
        }

        vm.openDomainSettingWebhook = function () {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/domain-webhook-setup.html',
                controller: domainSettingConfigurationController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    data: function () {
                        return {
                            domain: vm.domain,
                            email: vm.email,
                            webhook: vm.webhook,
                            trusted: vm.trusted,
                            settings: vm.setting,
                            newtrusted: vm.newtrusted
                        }
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                if (result.toSaveData.domainsToAdd.length > 0) {
                    UserAlertService.userAlertingSettings({alertType: 'webhook'}, result.toSaveData.domainsToAdd).$promise.then(function () {
                        vm.trustedDomainGeneralSettings();
                    });
                }
                if (result.toSaveData.domainsToDelete.length > 0) {
                    var cleanedArray = result.toSaveData.domainsToDelete.map((domain) => {
                        return {
                            alertSystemType: domain.alertSystemType,
                            domain: domain.domain,
                            id: domain.id,
                            trustedDomain: domain.trustedDomain
                        }
                    });
                    UserAlertService.deleteProvidedRequest({toDelete: cleanedArray});
                    vm.trustedDomainGeneralSettings();
                }
            });
        }

        vm.openThrottleSetting = function (type) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/throttle-configuration.html',
                controller: saveThrottleConfigurationController,
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    data: function () {
                        return {
                            type: type,
                            throttleUnit: vm.throttleUnit
                        }
                    }
                }
            }).result.then(function (result) {
                vm.isSaving = false;
                vm.saveThrottle(result.type, true, result.values);
            });
        }

        //Miscellaneous functions for specific page section (to check if used)
        vm.deleteTrusted = function (domain, type) {
            UserAlertService.checkUserDeleteAlertingSettings({id: domain.id}, function (result) {
                if (result.length > 0) {
                    $uibModal.open({
                        templateUrl: 'app/account/general-settings/alerting-settings-overview.html',
                        controller: 'AlertingSettingOverviewController',
                        backdrop: 'static',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            pagingParams: ['$stateParams', function () {
                                return {
                                    alertsToDelete: result,
                                    domainToDelete: domain.id
                                };
                            }]
                        }
                    }).result.then(function () {
                        vm.isSaving = false;
                        $timeout(function () {
                            vm.trustedDomainGeneralSettings();
                        }, 500);
                    });
                } else {
                    var found = Object.values(vm.newtrusted[type]).indexOf(domain.trustedDomain);
                    if (found > -1) {
                        var index = Object.values(vm.trusted[type]).indexOf(domain);
                        vm.trusted[type].splice(index, 1);
                        vm.newtrusted[type].splice(found, 1);
                    } else {
                        UserAlertService.delete({id: domain.id}, function () {
                            $timeout(function () {
                                vm.trustedDomainGeneralSettings();
                            }, 500);
                        });
                    }
                }
            });
        };

        function evaluate(field) {
            if (field === "" || field == null)
                return true;
        }

        vm.toggleMaintenance = function () {
            if (vm.showMaintenanceForm) {
                //turn off maintenance
                MaintenanceSettingsService.delete();
                vm.showMaintenanceForm = false;
            } else {
                vm.showMaintenanceForm = true;
            }
        };

        vm.openCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.maintenanceDatetime) {
                vm.maintenanceDatetime.isOpen = !vm.maintenanceDatetime.isOpen;
            } else {
                vm.maintenanceDatetime = {isOpen: true};
            }

        };

        vm.evaluateTypeMail = function (value, type) {
            if (value === "" || value == null) {
                if (type === "maintenance") {
                    if (evaluate(vm.maintenanceSetting.version)
                        && evaluate(vm.maintenanceSetting.features)
                        && evaluate(vm.maintenanceSetting.enhancements)
                        && evaluate(vm.maintenanceSetting.bugsFixing))
                        vm.mailType = "none";
                } else
                    vm.mailType = "none";
            } else {
                vm.mailType = type;
            }
        }
    }
})();
